import { ArrowRight, Lightning, Timer, Palette } from "@phosphor-icons/react";

const Hero = () => {
  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/dfe6d8b350190f6046e701baf5d53de61005068f2dfbda14a1f75701792efbb8.png"
          alt="Laser cutting MDF"
          className="w-full h-full object-cover"
        />
        <div className="hero-gradient absolute inset-0"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div 
            className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 mb-8"
            data-testid="hero-badge"
          >
            <Lightning weight="fill" className="text-[#00E5FF]" size={18} />
            <span className="text-sm text-[#A0AEC0] uppercase tracking-wider font-medium">
              Artesanato Premium
            </span>
          </div>

          {/* Title */}
          <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            Um <span className="gradient-text">Novo Conceito</span> em Artesanato Personalizado
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-[#A0AEC0] mb-8 leading-relaxed">
            Cortes precisos em MDF, gravação a laser em diversos materiais e peças únicas feitas do seu jeito. 
            <span className="text-white font-semibold"> Entrega na hora!</span>
          </p>

          {/* Features */}
          <div className="flex flex-wrap gap-6 mb-10">
            <div className="flex items-center gap-2 text-[#A0AEC0]">
              <Timer weight="fill" className="text-[#00E5FF]" size={20} />
              <span>Entrega Rápida</span>
            </div>
            <div className="flex items-center gap-2 text-[#A0AEC0]">
              <Palette weight="fill" className="text-[#D500F9]" size={20} />
              <span>100% Personalizado</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://wa.me/5527981761251?text=Olá! Gostaria de fazer um orçamento."
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button inline-flex items-center justify-center gap-2 bg-[#00E5FF] text-[#03030A] px-8 py-4 rounded-full font-bold text-lg hover:shadow-[0_0_30px_rgba(0,229,255,0.5)] transition-all"
              data-testid="hero-cta-primary"
            >
              <span>Solicitar Orçamento</span>
              <ArrowRight weight="bold" size={20} />
            </a>
            <a
              href="#servicos"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#servicos")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 border border-white/20 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/5 transition-all"
              data-testid="hero-cta-secondary"
            >
              <span>Ver Serviços</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-[#00E5FF] rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
